import { IconCog } from '@loadsmart/icons'

import { CARRIER_DEFAULT_HOME } from 'legacy/constants/tabs'

import I18n from '../I18n/i18n'

const urls = {
  loads: {
    title: I18n.get('ls.components.Navigation.link.loads'),
    url: CARRIER_DEFAULT_HOME,
  },
  fleet: {
    title: I18n.get('ls.components.Navigation.link.fleet'),
    url: '/#/fleet/',
  },
  fleetDrivers: {
    title: I18n.get('ls.components.Navigation.link.fleet'),
    url: '/#/fleet/drivers',
  },
  fleetTrucks: {
    title: I18n.get('ls.components.Navigation.link.fleet'),
    url: '/#/fleet/trucks',
  },
  'carrier/shipments': {
    title: I18n.get('ls.components.Navigation.link.shipments'),
    url: '/#/shipments/all',
  },
  tracking: {
    title: I18n.get('ls.components.Navigation.link.tracking'),
    url: '/#/tracking/',
  },
  rateConfirmation: {
    title: I18n.get('ls.components.Navigation.link.rateConfirmation'),
    url: '/#/rate-con/',
  },
  analytics: {
    title: I18n.get('ls.components.Navigation.link.analytics'),
    url: '/#/history/',
  },
  'carrier/truck-region': {
    title: I18n.get('ls.components.Navigation.link.account'),
    url: '/#/profile/carrier/preference',
    icon: <IconCog width="14px" height="14px" />,
  },
  book: {
    title: I18n.get('ls.components.Navigation.link.book'),
    url: '/#/quote/',
  },
  carrier: {
    title: I18n.get('ls.components.Navigation.link.carrier'),
    url: '/#/carrier/',
  },
  login: {
    title: I18n.get('ls.components.Navigation.link.login'),
    url: '/#/login',
  },
  signup: {
    title: I18n.get('ls.components.Navigation.link.signup'),
    url: '/#/signup',
  },
  signupPage: {
    title: I18n.get('ls.components.Navigation.link.signup'),
    url: '/#/signup',
  },
  forgot: {
    title: I18n.get('ls.components.Navigation.link.forgot'),
    url: '/#/forgot',
  },
  loadsmart: {
    title: 'Loadsmart',
    url: 'https://www.loadsmart.com/',
  },
  'user-agreement': {
    title: I18n.get('ls.components.Footer.link.ua'),
    url: 'https://www.loadsmart.com/user-agreement/',
  },
}

function getCurrent(url) {
  if (typeof window !== 'undefined') {
    url.includes(window.location.pathname)
  }
}

export const URL = {
  get(key, id = 0) {
    let item = urls[key]
    item.isCurrent = item.hasOwnProperty('isCurrent') ? item.isCurrent : getCurrent(item.url)

    if (id) {
      item.url = item.url.replace('{id}', id)
    }

    return item
  },
  go(id) {
    if (urls[id]) {
      URL.goLocation(urls[id].url)
    }
  },
  goLocation(location) {
    window.location = location
  },
}

export default URL
